import { createSelector } from 'reselect';
import getPOTGVisibility from '../../../PlayerOfTheGame/store/selectors/getPOTGVisibility';
const getShouldShowMessage = (state) => state?.promos?.shouldShowMessage;
const getPromos = (state) => state.promos ?? {};

export const inningStatesWeights = {
    top: 0,
    middle: 1,
    bottom: 2,
    end: 3
};

export const getShouldShowMessageState = createSelector(
    [getShouldShowMessage],
    (shouldShowMessage) => shouldShowMessage
);

export const getMatchedPromo = ({
    promoType,
    type,
    promoState,
    gameStatusLC,
    currentInningNum,
    promoInning,
    promoInningState,
    inningStateLC
}) => {
    if (promoType === type && promoState === gameStatusLC && currentInningNum >= promoInning) {
        if (currentInningNum === promoInning) {
            if (inningStatesWeights[inningStateLC] >= inningStatesWeights[promoInningState]) {
                return true;
            }
        } else if (currentInningNum > promoInning) {
            return true;
        }

        return false;
    }
};

const reduceToValidPromos = ({
    type,
    showPOTG,
    promotions
}) => {
    const { inningState, currentInning, gameStatus } = promotions;
    const reducer = (list, promo) => {
        const { rules } = promo;
        const matchedPromo = { ...promo };

        const inningStateLC = inningState?.toLowerCase();
        const currentInningNum = parseInt(currentInning);
        const gameStatusLC = gameStatus?.toLowerCase();
        const isMatchedPromo = getMatchedPromo({
            promoType: promo.type,
            type,
            promoState: promo.state,
            gameStatusLC,
            currentInningNum,
            promoInning: promo.inning,
            promoInningState: promo.inningState,
            inningStateLC
        });

        if (isMatchedPromo) {
            if (rules && rules === 'potg') {
                if (showPOTG) {
                    list.push(matchedPromo);
                }
            } else {
                list.push(matchedPromo);
            }
        }
        return list;
    };

    return reducer;
};

const getPromosState = (type) => {
    return createSelector(
        [getPromos, getPOTGVisibility],
        (promotions, { showPOTG }) => {
            const validPromosList = [];
            const { promos } = promotions;
            if (!promos || promos?.length === 0) {
                return validPromosList;
            }
            promos.reduce(reduceToValidPromos({ type, showPOTG, promotions }), validPromosList);
            return validPromosList;
        }
    );
};

export default getPromosState;
